module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nagios-dash"
  }, [_c('h1', [_vm._v("System Health & Availability")]), _vm._v(" "), _c('ul', {
    staticClass: "hostlist"
  }, _vm._l((_vm.hostList), function(value, key) {
    return _c('li', {
      key: key,
      staticClass: "host"
    }, [_c('div', {
      staticClass: "host-detail"
    }, [_c('div', {
      staticClass: "host-status",
      class: _vm._f("asHostCssClass")(value.host.status)
    }), _vm._v("\n\t\t\t\t" + _vm._s(key) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "servicelist"
    }, _vm._l((value.services), function(service) {
      return _c('div', {
        key: service.name,
        staticClass: "service"
      }, [_c('div', {
        staticClass: "service-status",
        class: _vm._f("asServiceCssClass")(service.status)
      }), _vm._v("\n\t\t\t\t\t" + _vm._s(service.description) + "\n\t\t\t\t")])
    }))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-375ccaf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/nagios-dash.vue
// module id = 568
// module chunks = 0